import { create } from "zustand";

interface AuthModalStore {
  isLoginModalOpen: boolean;
  loginCallback?: () => void; // Callback khi login thành công

  actions: {
    openLoginModal: (callback?: () => void) => void;
    closeLoginModal: () => void;
    executeCallback: () => void;
  };
}

const useAuthModalStore = create<AuthModalStore>((set, get) => ({
  isLoginModalOpen: false,
  loginCallback: undefined,

  actions: {
    openLoginModal: (callback) => {
      set({
        isLoginModalOpen: true,
        loginCallback: callback,
      });
    },

    closeLoginModal: () => {
      set({
        isLoginModalOpen: false,
        loginCallback: undefined,
      });
    },

    executeCallback: () => {
      const { loginCallback } = get();
      if (loginCallback) {
        loginCallback();
      }
      get().actions.closeLoginModal();
    },
  },
}));

// Fix: Tách riêng từng selector để tránh tạo object mới
export const useIsLoginModalOpen = () =>
  useAuthModalStore((state) => state.isLoginModalOpen);

export const useLoginCallback = () =>
  useAuthModalStore((state) => state.loginCallback);

export const useAuthModalActions = () =>
  useAuthModalStore((state) => state.actions);

export default useAuthModalStore;
